import React from 'react';
import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter
} from "mdbreact"

const ModalConfirmSent = ({ item, handlerFn = () => null, closeFn = () => null, open = false }) => {
  return (
    <MDBModal isOpen={open} toggle={closeFn}>
      <MDBModalHeader
        className="text-center"
        titleClass="w-100 font-weight-bold">
        Send request 
      </MDBModalHeader>
      <MDBModalBody>
        <p>APC questionnaire will be sent to:</p>
        {item ? item.extracted.map((item) => <p>{item.email}</p>) : null}
      </MDBModalBody>
      <MDBModalFooter className="justify-content-center">
        <MDBBtn color="primary" onClick={handlerFn}>Send</MDBBtn>
        <MDBBtn color="secondary"  onClick={closeFn}>Cancel</MDBBtn>
      </MDBModalFooter>
    </MDBModal>
  )
}

export default ModalConfirmSent;
